import { MarketPlace } from "@/types/market-place";

export interface LabelTemplateObjectDTO {
  objectType: LabelTemplateObjectType;
  alignmentType: LabelTemplateObjectAlignmentType;
  textType: LabelTemplateTextType;
  plainText: string;
  domainObjectPropertyTypes: DomainObjectPropertyType[];
  enableLineBreaks: boolean;
  numberOfMaximumNumberOfLines: number;
  textSize: number;
  textFont: string;
  condition: string;
  topMargin: number;
  leftMargin: number;
  bottomMargin: number;
  rightMargin: number;
  barcodeType: BarcodeType;
  displayBarcodeText: string;
  barcodeHeightInMm: number;
  barcodeSize: number;
  labelObjectOrientation: LabelObjectOrientation;
  plainTextPosition: LabelObjectPlainTextPosition;
}

export interface LabelTemplateDTO {
  partnerId: string;
  isDefault: boolean;
  countOfCopies: number;
  destinationType: LabelTemplateDestinationType;
  labelTemplateName: string;
  labelDPIResolution: LabelTemplateDPIResolution;
  labelWidthInMm: LabelWidthInMm;
  labelHeightInMm: LabelHeightInMm;
  imageWidth: number;
  imageHeight: number;
  productForPreview: string | null;
  labelTemplateObjects: LabelTemplateObjectDTO[];
  id: string;
  attachedPrinterName: string | null;
}

export enum LabelObjectOrientation {
  Horizontal = 0,
  UpDown,
  DownUp,
}

export enum LabelTemplateDestinationType {
  ProductItemFBM = 0,
  Box,
  Supply,
  ProductItemWbFBS,
  ProductItemOzonFBS,
}

export enum LabelObjectPlainTextPosition {
  Left = 0,
  Right,
}

export enum LabelTemplateDPIResolution {
  ThreeHundred = 0,
  TwoHundredAndThree,
}

export enum LabelTemplateObjectType {
  Text = 0,
  Barcode,
  CurrentDateAndTimeOfTheUserMachine,
  SupplyBarcode,
  BoxBarcode,
  FbsWBBarcode,
  Logo,
  FbsOzonBarcode,
}

export enum LabelTemplateObjectAlignmentType {
  Left = 0,
  Right,
  Centered,
}

export enum LabelTemplateTextType {
  PlainText = 0,
  DomainObjectProperty,
}

export enum DomainObjectPropertyType {
  ProductName = 0,
  ProductBarcode,
  // ProductAdditionalInformation,
  // ProductCategory,
  ProductBrand,
  // ProductArticle,
  // ProductArticleToCombineInOneCard,
  ProductOzonArticle,
  ProductWildberriesArticle,
  Organization,
  ManufacturersName,
  ManufacturersINN,
  ManufacturersAddress,
  ManufacturersCountry,
  ProductColor,
  ProductSize,
  ManufacturersSize,
  ProductComposition,
  // PackagingWidth,
  // PackagingHeight,
  // PackagingDepth,
  // PackagingLength,
  CareOfThings,
  TNVED,
  // ProductPrice,
  // PriceWithoutDiscount,
  ProductShelfLife,
}

export enum BarcodeType {
  EAN13 = 0,
  EAN8,
  CODE128,
  QRCode,
  DataMatrix,
  GS1DataMatrix,
}

export enum LabelHeightInMm {
  SMALL = 40,
  LARGE = 75,
}

export enum LabelWidthInMm {
  SMALL = 58,
  LARGE = 120,
}

export enum LabelTemplateTextFont {
  ARIAL = "Arial",
  HELVETICA = "Helvetica",
  VERDANA = "Verdana",
  TAHOMA = "Tahoma",
  COURIER_NEW = "Courier New",
  TIMES_NEW_ROMAN = "Times New Roman",
}

export const DESTINATION_TYPE_BY_MARKETPLACE: Record<
  MarketPlace,
  LabelTemplateDestinationType | null
> = {
  [MarketPlace.ChestniyZnak]: null,
  [MarketPlace.YandexMarket]: null,
  [MarketPlace.Wildberries]: LabelTemplateDestinationType.ProductItemWbFBS,
  [MarketPlace.Ozon]: LabelTemplateDestinationType.ProductItemOzonFBS,
};
